export const LOGIN = "/login";
export const REQUESTLIST = "/formTypes";
export const SUBMITTED = "/formTransactions";
export const DRAFT = "/formTransactions";
export const GET_MASTER_DATA = "/master-data";
export const USER = "/users";
export const PREVIEW = "/formTransactions";
